<template>
  <div class="activityDetails">
    <div class="info_title">
      <div class="box_y">{{ $route.query.name }}活动详情</div>
      <div class="box_e">举办{{ ActivityListByEstateIdData.total }}场活动</div>
      <div class="box_e">
        总参与人数{{ ActivityListByEstateIdData.peopleNum }}人
      </div>
      <div class="box_s">
        <div
          v-for="(item, key) in dataOne"
          :key="key"
          class="box_s_item"
          @click="look(item, key + 1)"
        >
          <a class="ant-dropdown-link" @click.prevent>
            <div class="click_btn">
              <div v-if="key == 0" class="click_btn_y">最近1场</div>
              <div v-else class="click_btn_y">第{{ key + 1 }}场</div>
            </div>
          </a>
        </div>
        <div v-if="dataTwo.length > 0" class="box_s_item">
          <a-dropdown>
            <a class="ant-dropdown-link" @click.prevent>
              <div class="click_btn">
                <div class="click_btn_y" v-if="changIndex < 5">查看更多</div>
                <div class="click_btn_y" v-else>第{{ changIndex }}场</div>
                <div class="click_btn_e"></div>
              </div>
            </a>
            <template #overlay>
              <a-menu>
                <a-menu-item
                  v-for="(item, key) in dataTwo"
                  :key="key"
                  @click="look(item, key + 5)"
                >
                  <a href="javascript:;">第{{ key + 5 }}场</a>
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
      </div>
    </div>
    <div class="commonTitle">
      活动信息
    </div>

    <a-row class="basicInfo">
      <div class="activeContent">
        <div class="contentTitle">活动内容:</div>
        <div class="contentInfo">{{ content }}</div>
      </div>
      <a-col :span="12" class="commonCol">
        <a-row
          v-for="(item, index) in leftInfos"
          :key="index"
          :gutter="8"
          class="commonHeight"
        >
          <a-col :span="6" align="right"> {{ index | titleFilter }}: </a-col>
          <a-col :span="18">
            <div class="commonLine">
              {{ item }}
            </div>
          </a-col>
        </a-row>
      </a-col>
      <a-col :span="12" class="commonCol">
        <a-row
          v-for="(item, index) in rightInfos"
          :key="index"
          :gutter="8"
          class="commonHeight"
        >
          <a-col :span="6" align="right"> {{ index | titFilter }}: </a-col>
          <a-col :span="18">
            <div class="commonLine">
              {{ item }}
            </div>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
    <div class="commonTitle">
      活动照片
    </div>
    <a-row class="imgHeight" :gutter="8">
      <a-col :span="3" align="right">
        现场活动照片:
      </a-col>
      <a-col :span="21">
        <div v-if="activityPhotoList.length === 0" class="viewPicture"></div>
        <div v-else class="imgLine">
          <img
            v-for="(item, index) in activityPhotoList"
            :key="index"
            :src="item"
            class="activityPhoto"
            @click="showPicture(item)"
          />
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24" class="bottomBtn">
        <a-button type="primary" @click="backPage()">
          返回
        </a-button>
      </a-col>
    </a-row>
    <a-modal v-model="picVisible" :footer="null">
      <img :src="picSrc" />
    </a-modal>
  </div>
</template>
<script>
import { getActivityDetails, getActivityListByEstateId } from "@/api/activity";
import t from "../../../static/ezuikit";
export default {
  name: "ActivityDetails",
  filters: {
    titleFilter: function(value) {
      switch (value) {
        case "dateTime":
          return "活动开始时间";
        case "peopleNum":
          return "参与人数";
        case "createUser":
          return "活动创建人";
        default:
          return "字段值异常，请检查后台数据";
      }
    },
    titFilter: function(value) {
      switch (value) {
        case "endTime":
          return "活动结束时间";
        case "createTime":
          return "活动创建时间";
        case "mobile":
          return "创建人手机号";
        default:
          return "字段值异常，请检查后台数据";
      }
    }
  },
  data() {
    return {
      ActivityListByEstateIdData: {},
      dataOne: [],
      dataTwo: [],
      content: "",

      leftInfos: {
        dateTime: "",
        peopleNum: "",
        createUser: ""
      },
      rightInfos: {
        endTime: "",
        createTime: "",
        mobile: ""
      },
      aId: "",
      activityPhotoList: [],
      picSrc: "",
      picVisible: false,
      changIndex: 1
    };
  },
  mounted() {
    this.getActivityListByEstateId();
  },
  methods: {
    look(a, b) {
      console.log(b);
      this.changIndex = b;
      this.getInfo({
        id: a
      });
    },
    getActivityListByEstateId() {
      getActivityListByEstateId({
        estateId: this.$route.query.id
      }).then(res => {
        if (res.code == 0) {
          this.ActivityListByEstateIdData = res.result;
          const ary = Object.keys(res.result.pageMap);
          console.log(ary[ary.length - 1]);
          if (ary[ary.length - 1] > 4) {
            for (let i = 1; i < 5; i++) {
              this.dataOne.push(res.result.pageMap[i]);
            }
            for (let j = 5; j <= ary[ary.length - 1]; j++) {
              this.dataTwo.push(res.result.pageMap[j]);
            }
          } else {
            for (let i = 1; i <= ary[ary.length - 1]; i++) {
              this.dataOne.push(res.result.pageMap[i]);
            }
          }
          this.getInfo({
            id: res.result.pageMap[1]
          });
        }
      });
    },
    getInfo(params) {
      getActivityDetails(params).then(res => {
        this.content = res.result.activityInfo.content;
        // this.leftInfos.title = res.result.activityInfo.title;
        this.leftInfos.dateTime = res.result.activityInfo.dateTime;
        this.leftInfos.peopleNum = res.result.activityInfo.peopleNum;
        this.leftInfos.createUser = res.result.activityInfo.createUser;
        // this.rightInfos.estateName = res.result.activityInfo.estateName;
        this.rightInfos.endTime = res.result.activityInfo.endTime;
        this.rightInfos.createTime = res.result.activityInfo.createTime;
        this.rightInfos.mobile = res.result.activityInfo.mobile;
        this.activityPhotoList = res.result.activityImage;
      });
    },
    showPicture(url) {
      this.picSrc = url;
      this.picVisible = true;
    },
    backPage() {
      this.$router.push({ path: "/activity/propagandaList" });
    }
  }
};
</script>
<style lang="stylus" scoped>
.activityDetails
  background-color #fff
  padding 16px 20px
  margin-bottom 20px
  font-size 12px
  color #000
  .commonTitle
    font-size 16px
    font-weight 600
    color #333
  .basicInfo
    margin 16px 0
    .commonCol
      .commonHeight
        height 32px
        line-height 32px
        margin 16px 0
        .commonLine
          background-color #f2f2f2
          height 32px
          line-height 32px
          padding 0 11px
          color #333
  .imgHeight
    margin 16px 0
    .imgLine
      .activityPhoto
        height 90px
        margin 0 16px 16px 0
        cursor pointer
  .viewPicture
    width 104px
    height 104px
    background-color #fafafa
    border 1px dashed #d9d9d9
    border-radius 4px
  .viewPicture:hover
    border 1px dashed #1890FF
  .bottomBtn
    margin 8px 0 24px 0
    text-align center
.info_title{
    margin-bottom: 40px;
}
.box_y{
    font-size: 18px;
    font-weight: 700;
}
.box_e{
    font-size: 12px;
}
.box_s{
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.box_s_item{
    width 80px;
    font-size: 12px;
}
.click_btn{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.click_btn_e{
    width 20px;
    height: 20px;
    background: url(../../assets/image/xiala.png) no-repeat;
    background-size: 100%;
}
.activeContent{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
}
.contentTitle{
    width 208px;
    padding:0 4px;
    text-align: right;
    line-height: 32px;
    height 32px;
}
.contentInfo{
    width calc(100% - 208px);
    background-color: #f2f2f2;
    height: 32px;
    line-height: 32px;
    padding: 0 11px;
    color: #333;
}
</style>
